import { createSelector } from 'reselect';
import { getWorkOrderManagement } from './getWorkOrderManagement';

export const getShiftIntroOpen = createSelector(
  [getWorkOrderManagement],
  (workOrderManagement) => {
    return workOrderManagement.shiftIntroOpen;
  }
);
